import { useState } from 'react';
import PropTypes from 'prop-types';
import './ExpandableTable.scss';

const ExpandableChilds = ({ process }) => {
    const childProcesses = (childProcess) => (childProcess.children || []).map((proc, index) => {
        return <li key={index}>
            {<ExpandableTableRow process={proc}> </ExpandableTableRow>}
            {proc.children && <ul>{childProcesses(proc.children)}</ul>}
        </li>;
    });

    return <> {childProcesses(process)}</>;
};

ExpandableChilds.propTypes = {
    process: PropTypes.object.isRequired
};

const ExpandableTableRow = ({ process }) => {
    const [isExpandedRow, setisExpandedRow] = useState(false);
    const [expandSymbol, setExpandSymbol] = useState('icon-angle-down');

    const handleClick = () => {
        setisExpandedRow(!isExpandedRow);
        isExpandedRow ? setExpandSymbol('icon-angle-down') : setExpandSymbol('icon-angle-up');
    };

    const generateExpandableRowDom = (proc) => {
        return <table onClick={handleClick} className='expandSymbol' key={proc.pid}>
            <tbody>
                <tr>
                    <td className="tabletd firstColumn">
                        <div className={`d-flex flex-row align-items-top procInfo ${proc.children && 'expandableProcessInfo'}`}>
                            {proc.children && <i className={`icon ${expandSymbol}`} />}

                            <div className='d-flex flex-column'>
                                <span>{proc.process_name}</span>
                                <span>PID: {proc.pid}</span>
                            </div>
                        </div>
                    </td>
                    <td className="tabletd path">{proc.process_path}</td>
                    <td className="tabletd pid">Process creation</td>
                </tr>
            </tbody>
        </table>;
    };

    return (<ul key={process?.pid}>
        <li key={process?.pid}>
            {generateExpandableRowDom(process)}
            <ul className='childProcesses'>
                {isExpandedRow && <ExpandableChilds process={process}> </ExpandableChilds>}
            </ul>
        </li>
    </ul>);
};

ExpandableTableRow.propTypes = {
    process: PropTypes.object.isRequired,
};

export default ExpandableTableRow;
